export const delay = (duration: number): Promise<void> =>
  new Promise((resolve) => window.setTimeout(resolve, duration));

export const defer = (callback: () => void) => window.setTimeout(callback, 0);

export const nextFrame = window.requestAnimationFrame
  ? (): Promise<void> => new Promise((resolve) => requestAnimationFrame(() => resolve()))
  : () => delay(0);
